module.exports = __webpack_public_path__ + "img/32.5fd87cb6.png";